import { PropsWithChildren } from 'react'

import FooterSection from '@/components/sections/FooterSection'
import { LenisProvider } from '@/contexts/lenis'
import useChangePathname from '@/hooks/useChangePathname'

import { WPPageData } from '@/types'

export type LayoutProps = PropsWithChildren<{ pageData: WPPageData }>

const Layout = ({ children }: LayoutProps) => {
  useChangePathname()

  return (
    <LenisProvider>
      <div id="sections" className="opacity-0 lg:flex lg:h-full">
        {children}
        <FooterSection />
      </div>
    </LenisProvider>
  )
}

export default Layout
